export const USE_TYPE = {
  KBPAY: 'A9t7K2bQ',
  MSTOCK: '00000011',
  jb: '00000012',
  hana: '00000013'
}

export const DEFAULT_USE_TYPE = USE_TYPE.KBPAY

export const APP_TARGET_CONFIG = {
  ASP: {
    envModes: {
      development: 'development',
      staging: 'staging',
      production: 'production'
    },
    routesPath: 'src/routes/AspRoutes.jsx',
    loadingPath: 'src/pages/Loading.jsx',
    stylePath: 'src/styles/entries/asp.css'
  },

  MSTOCK: {
    envModes: {
      development: 'miraeasset-dev',
      staging: 'miraeasset-staging',
      production: 'miraeasset-prod'
    },
    routesPath: 'src/routes/MStockRoutes.jsx',
    loadingPath: 'src/pages/MStockLoading.jsx',
    stylePath: 'src/styles/entries/mstock.css'
  },

  hana: {
    envModes: {
      development: 'hana-dev',
      staging: 'hana-staging',
      production: 'hana-prod'
    },
    routesPath: 'src/routes/HanaRoutes.jsx',
    loadingPath: 'src/pages/HanaLoading.jsx',
    stylePath: 'src/styles/entries/hana.css'
  },

  jb: {
    envModes: {
      development: 'jb-dev',
      staging: 'jb-staging',
      production: 'jb-prod'
    },
    routesPath: 'src/routes/JbRoutes.jsx',
    loadingPath: 'src/pages/Loading.jsx',
    stylePath: 'src/styles/entries/jb.css'
  }
}
